import { APP_ENV } from "../environments/environment";

export const isDevEnv = () => {
  return APP_ENV === "development";
};
